module.exports = __webpack_public_path__ + "img/table-head.c7b2fc16.png";